import { render, staticRenderFns } from "./TickInSettings.vue?vue&type=template&id=5a74227a"
import script from "./TickInSettings.vue?vue&type=script&lang=js"
export * from "./TickInSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports